import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import { useFetchLivePlayMutationStore } from '../../stores/useFetchLivePlayMutationStore';
import usePlayInformationStore from '../../stores/usePlayInformationStore';

/**
 *
 * usePlayInformationStore 초기화
 */
function useRealTimePlayInformation() {
  const $ = _c(6);
  const playInfo = useFetchLivePlayMutationStore(_temp);
  const setLike = usePlayInformationStore(_temp2);
  const setBookmark = usePlayInformationStore(_temp3);
  let t0;
  if ($[0] !== playInfo || $[1] !== setBookmark || $[2] !== setLike) {
    t0 = () => {
      if (!playInfo) {
        return;
      }
      setLike(playInfo.media.likeCnt);
      setBookmark(playInfo.media.bookmarkCnt);
    };
    $[0] = playInfo;
    $[1] = setBookmark;
    $[2] = setLike;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  let t1;
  if ($[4] !== playInfo) {
    t1 = [playInfo];
    $[4] = playInfo;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  useEffect(t0, t1);
}
function _temp3(state_1) {
  return state_1.setBookmark;
}
function _temp2(state_0) {
  return state_0.setLike;
}
function _temp(state) {
  return state.data;
}
export default useRealTimePlayInformation;